import { render, staticRenderFns } from "./NavigationPagev2.vue?vue&type=template&id=62f6e6ad&scoped=true&"
import script from "./NavigationPagev2.vue?vue&type=script&lang=js&"
export * from "./NavigationPagev2.vue?vue&type=script&lang=js&"
import style0 from "./NavigationPagev2.vue?vue&type=style&index=0&id=62f6e6ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f6e6ad",
  null
  
)

export default component.exports